export default function removeBall() {
  // this.balls.shift();
}
